export default __webpack_public_path__ + "static/media/new-message.62b7b230.svg";